"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Assign random id to element or returns existing one.
 */
function assignId(element) {
    if (element.id) {
        return element.id;
    }
    else {
        var id = randomId();
        element.id = id;
        return id;
    }
}
exports.assignId = assignId;
/**
 * Random id generator.
 */
function randomId() {
    return 'i' + (Number(Math.random().toString().slice(2))).toString(36);
}
exports.randomId = randomId;
